export default __webpack_public_path__ + "static/066-67873d82f33def26ed89886a531e57de.jpg";